<template>
  <div>
    <sidepanel id="panel-kits" title="Select test kit" @open="getKits">
      <div
        v-for="(kit, index) in kits"
        :key="'kit-' + index"
        class="kit"
        @click="selectKit(kit)"
      >
        <div>
          <strong>{{ kit.name }}</strong>
        </div>
        <div>
          {{ kit.description }}
        </div>
        <div>DKK{{ kit.cost }}</div>
        <div>
          {{ kitMarkers(kit.markers).join(", ") }}
        </div>
      </div>
    </sidepanel>
  </div>
</template>

<script>
import { firestore } from "@/firebase";
export default {
  data() {
    return {
      kits: null
    };
  },
  methods: {
    kitMarkers(markers) {
      return Object.keys(markers).map(marker => markers[marker].title);
    },
    selectKit(kit) {
      this.$emit("select", kit);
      this.removePanel();
    },
    getKits() {
      firestore
        .collection("kits")
        .get()
        .then(snap => {
          this.kits = snap.docs.map(doc => ({ ...doc.data() }));
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";
.kit {
  padding: @hh @h1;
  border: 1px solid #eee;
  & > div {
    padding: @hh 0;
    & + div {
      border-top: 1px solid #eee;
    }
  }
  & + .kit {
    margin-top: @h1;
  }
  cursor: pointer;
  &:hover {
    background-color: #ffffcc;
  }
}
</style>
